import { render, staticRenderFns } from "./DuplicatesView.vue?vue&type=template&id=87b8cf1e&scoped=true"
import script from "./DuplicatesView.vue?vue&type=script&lang=js"
export * from "./DuplicatesView.vue?vue&type=script&lang=js"
import style0 from "./DuplicatesView.vue?vue&type=style&index=0&id=87b8cf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b8cf1e",
  null
  
)

export default component.exports